export default "__VITE_ASSET__88650589__"